<template>
  <div class="index"></div>
</template>

<script lang="js">
export default {
name: "Index",
mounted() {
  this.$router.push({name: "LoginMaster"});
},
};
</script>

<style scoped lang="scss">
background {
  background-color: #f8f8f8;
}
</style>
